import type { ReactNode } from 'react'

// Shared card chrome for dashboard widgets — was hand-duplicated as
// "bg-white rounded-xl shadow-xs border border-gray-100 p-6" across
// ExecutiveDashboard/AnalystView/ReportsPage (docs/plan-executive-
// dashboard-focuses.md). Deliberately just the frame, not a prescribed
// header layout — widgets need wildly different headers (a bare KPI grid
// needs none, the map needs a zone picker + fullscreen button, demands-
// attention needs a collapse toggle), so dictating one header shape here
// would fight every real usage instead of serving it. The free-form focus
// mode this is scaffolding for only needs every widget to share this same
// outer frame, not identical internals.
export function Widget({ className = '', accent = 'border-gray-100', children }: {
  className?: string
  accent?: string
  children: ReactNode
}) {
  return (
    <div className={`bg-white rounded-xl shadow-xs border p-6 ${accent} ${className}`}>
      {children}
    </div>
  )
}
